<div class="wrapper bg-area">
  <section id="pagamento-debito">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active">Pagamento</li>
              <li>Segurança</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <form class="dados-pessoais" [formGroup]="form">

              <h4>DADOS DE PAGAMENTO</h4>
              <p>Agora, seus Dados de Pagamento</p>

              <div class="metodo-credito">
                <div class="area-card">
                  <img class="icon-cartao-verde icon-verde" src="./assets/img/icon-boleto.png">
                </div>

                <p class="opcao-pagamento">
                  <strong>BOLETO BANCÁRIO</strong>
                  <br>
                  <a href="/pagamentos"><small>Trocar método de pagamento</small></a>
                </p>
              </div>

              <p class="opcao-cobranca"><strong>DIA DO DÉBITO</strong></p>

              <div class="radio-selector">
                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="08">
                  <span class="checkmark">08</span>
                </label>

                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="20">
                  <span class="checkmark">20</span>
                </label>

                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="30">
                  <span class="checkmark">30</span>
                </label>
              </div>
              <div>
                <span class="campo-erro"
                  *ngIf="showError('debitoDataPagamento')">{{getErrorMessage('debitoDataPagamento')}}</span>
              </div>

              <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>CEP</label>
                <input [class]="fieldCssClass(form, 'cep')" formControlName="cep" (focusout)="buscarCep($event, form)"
                  name="cep" type="text" placeholder="CEP" mask="00000-000" mask-output="alphanumeric" required>
                <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Endereço</label>
                <input [class]="fieldCssClass(form, 'logradouro')" formControlName="logradouro" name="endereco"
                  type="text" placeholder="Endereço" required>
                <span class="campo-erro" *ngIf="showError('logradouro')">{{getErrorMessage('logradouro')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Número</label>
                <input [class]="fieldCssClass(form, 'numero')" formControlName="numero" name="numero" type="text"
                  placeholder="Número">
                <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Complemento</label>
                <input [class]="fieldCssClass(form, 'complemento')" formControlName="complemento" name="complemento"
                  type="text" placeholder="Complemento">
                <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
              </div>

              <app-termo-uso (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)" [type]="'pagamento'"></app-termo-uso>


              <span class="voce-seguro">Seus dados só serão utilizados para comunicação entre a Montreal e você e jamais
                serão divulgados a terceiros.</span>

            </form>
          </div>

          <div class="column is-6 resumo-compra" *ngIf="propostaResult">
            <div class="area-fixed-resumo">
              <div class="seu-plano">
                <h4>Seu Plano</h4>

                <label class="small-label label-pessoas">
                  <span><i class="fas fa-user-plus"></i> <strong>{{countPessoas}}</strong> Pessoas</span>
                </label>
                <label class="small-label">
                  <span><i class="fas fa-bed"></i>
                    <strong>{{propostaResult ? propostaResult.quartoDuplo : '0'}}</strong>
                    Quarto <br><span class="coluna-left">Duplo</span></span>
                </label>
                <label class="small-label">
                  <span><i class="fas fa-bed"></i>
                    <strong>{{propostaResult ? propostaResult.quartoTriplo : '0'}}</strong>
                    Quartos <br><span class="coluna-left">Triplo</span></span>
                </label>
                <br>
                <p class="colunas"><span>Plano {{categoriaTituloDescritivo()}}</span><span class="coluna-right">{{countDiarias}}
                    diárias</span></p>
                <p class="colunas"><span>Taxa de Adesão</span><span class="coluna-right" appCurrencyMask>
                    {{propostaResult ? propostaResult.valorAdesao.toString() : '0' }}</span>
                </p>
                <p class="colunas"><span><strong>Total</strong></span><span class="coluna-right"><strong>
                      {{propostaResult ? propostaResult.valorMensalidade.toString() : '0'}}</strong></span>
                </p>

                <p class="add-cupom"><strong><i class="fas fa-ticket-alt"></i>Cupom</strong></p>

                <input type="text" [(ngModel)]="cupom" class="sucess" placeholder="Insira um cupom" name="cupom"
                  (input)="limpacupom()">
                <label class="text-sucess" *ngIf="isCupomValido == null && cupom" style="cursor: pointer;"
                  (click)="validaCupom()">Aplicar cupom</label>
                <label class="text-sucess" *ngIf="isCupomValido != null && isCupomValido && cupom">Cupom
                  aplicado</label>
                <label class="text-error" *ngIf="isCupomValido != null && !isCupomValido && cupom">O Cupom Não
                  Existe</label>
                <p *ngIf="mensagemCupom" class="prazo-cupom"><small>{{mensagemCupom}}</small></p>
                <p *ngIf="!mensagemCupom">&nbsp;</p>

                <p *ngIf="isCupomValido != null && isCupomValido && cupom" class="valores-cupom"><strong>Taxa de
                    adesão</strong> <span>De</span> <span class="line-through">R$
                    {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}</span> <small>Por</small> <span
                    class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                </p>

                <p *ngIf="!isCupomValido" class="valores-cupom"><strong>Taxa de adesão</strong>
                  <span></span> <span class="line-through"></span> <small></small>
                  <span class="valor-final">R$ {{propostaResult.valorAdesao.toString()}}</span>
                </p>

                <p *ngIf="isCupomValido != null && isCupomValido && cupom" class="valores-cupom">
                  <strong>Mensalidade</strong> <span>De</span> <span class="line-through">R$
                    {{propostaResult && propostaResult.valorMensalidade? propostaResult.valorMensalidade.toString() : '0'}}</span>
                  <small>Por</small> <span
                    class="valor-final">{{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                  </span>
                </p>

                <p *ngIf="!isCupomValido" class="valores-cupom"><strong>Mensalidade</strong> <span></span> <span
                    class="line-through"></span> <small></small> <span class="valor-final">R$
                    {{propostaResult.valorMensalidade}}</span>
                </p>

                <p class="valor-plano"><strong>Valor do Plano</strong> <span class="valor"><small>
                    </small>{{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                    /
                    <span>mês</span></span></p>
              </div>
              <button (click)="submit()" type="button" [disabled]="form.invalid"
                [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'"><i
                  class="fas fa-arrow-right"></i>CONTINUAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
